import React, { Component, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Picker from 'react-datepicker';
import moment from 'moment';
import MaskedInput from 'react-maskedinput';

class CustomInput extends Component {
	render() {
		const { id, name, value, onClick, onChange, onExit } = this.props;
		return (
			<div className='ui input'>
				<div className='ui icon input' style={{ width: '150px' }}>
					<MaskedInput name={name} id={id} mask='11/11/1111' onClick={onClick} onChange={onChange} value={value} onBlur={onExit} placeholder='MM/DD/YYYY' />
					<i aria-hidden='true' className='calendar icon'></i>
				</div>
			</div>
		);
	}
}

const DatePicker = (props) => {
	const newProps = { ...props };

	const [selectedDate, setSelectedDate] = useState(null);

	newProps.onChange = (date, e) => {
		const isDate = moment(e.target.value, 'MM/DD/YYYY', true).isValid();

		if (isDate) {
			setSelectedDate(moment(date));
			props.onChange(e, { ...props, value: date });
		}
	};

	newProps.onSelect = (date, e) => {
		props.onChange(e, { ...props, value: date });
	};

	const onExit = useCallback(
		(e) => {
			if (selectedDate) {
				if (selectedDate.diff(moment(e.target.value))) {
					props.onChange(e, { ...props, value: null });
				}
			} else {
				props.onChange(e, { ...props, value: null });
			}
		},
		[props, selectedDate]
	);

	newProps.customInput = <CustomInput onExit={onExit} />;
	return <Picker {...newProps} />;
};

DatePicker.propTypes = {
	onChange: PropTypes.func.isRequired,
};

export default DatePicker;
